export default {
    0: 'An unexpected error occurred',
    401: 'Since your session has expired, you have been logged out automatically.',
    403: 'Access denied!',
    100000: 'Validation failed',
    100100: 'The requested element could not be found. Please try again at a later time.',
    100200: 'There are still links zu company-macro-trends',
    100300: 'The company-macro-trend cannot be deleted, because it’s part of trend radars for which you don’t have any ' +
    'administrative rights. Please contact an administrator (trendmanager@trendone.com).',
    100500: 'The transmitted information is faulty. Please check the entries.',
    100600: 'E-mail address already in use',
    200000: 'Unfortunately the maximum amount of user for your account is reached. Please contact us at trendmanager@trendone.com.',
    200001: 'Unfortunately the maximum amount of manager for your account is reached. Please contact us at trendmanager@trendone.com.',
    401001: 'Your account is disabled. Please contact the administrator at trendmanager@trendone.com',
    401002: 'Your account has expired',
    401003: 'Invalid username or password',
    401004: 'Your link to set the password has unfortunately expired. Please use the password-forgotten function or ' +
    'contact the administrator at trendmanager@trendone.com',
    401005: 'Your AD account is not authorized for login.',
    401006: 'Please use the single-sign-on access for your organization. Simply click on the lock icon.',
    401101: 'The 2FA code you have used is invalid',
    401102: 'You have exceeded the number of attempts',
    401103: 'You have exceeded the time available for entering the code',
    404100: 'The action could not be performed. The C&O may have been updated by another person in the meantime. Please reload the page and try again.',
    noMatch: 'An unknown error occurred',
    unknownCode: 'An unknown error occurred'
}
